import React from 'react';
import SalesReturnForm from './SalesReturnForm';
import { useParams } from 'react-router-dom';

const EditSalesReturnPage = () => {
    const { id } = useParams(); // Get Sales Return ID from URL
    
    // Renders the form in 'edit' mode
    // (Depending on your form logic, this might be read-only for posted returns)
    return id ? <SalesReturnForm formType="edit" currentId={id} /> : <div>Loading...</div>;
};

export default EditSalesReturnPage;